const COUNTRY_API = '/sitecore/api/ssc/isagenix/globalcontentapi/1/';

export async function changeContextForCountry(region, langSelection) {
    var contextItemID = $('#hidden-context-item').val();
    var shareCode = $('#recommendedCart-sharecode').val();
    var url = `${COUNTRY_API}/GlobalCountryLanguageSelectorModalSetCookie?Region=${region}&langSelection=${langSelection}&itemID=${contextItemID}`;
    if(shareCode != null) { url += `&ShareCode=${shareCode}`; }
    return $.ajax({
        type: 'POST',
        url: url
    });
}
